<template>
    <div class="order_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <li class="li-title_1">采购订单</li>
                    <li class="li-title_2">
                        <router-link to="/ccqbdd" class="r_link">全部订单</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/cgd" class="r_link">创建采购单</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/dsh" class="r_link">待审核</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/ddh" class="r_link">待收货</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/yyc" class="r_link">已完成</router-link>
                    </li>
                    <li class="li-title_1">供货商管理</li>
                    <li class="li-title_2">
                        <router-link to="/gys" class="r_link">供货商</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/shdz" class="r_link">收货地址</router-link>
                    </li>
                </ul>
            </el-aside>
            <el-main>
                <router-view>

                </router-view>
             </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: "orderIndex",
        components:{
        },
        data() {
            return {
            }
        },
        created() {

        },
        methods: {
        },
        mounted() {}
    }
</script>

<style scoped>
    @import '../../assets/css/order.css';
    .order_index{
        width: 100%;
    }
    .left_url_tab{
        border: 1px solid #c7c7c7;
        font-size: 13px;
    }
    

    .li-title_1{
        height: 32px;
        line-height: 32px;
        background-color: #c1c1c154;
        vertical-align: top;
        padding-left: 5px;
        font-weight: 600;
    }
    .li-title_2{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
    }
    .li-title_3{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 40px;
    }
    .li-title_2:hover,.li-title_3:hover{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .li-help{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        text-align: center;
        font-size: 16px;
    }
    .li-help a{
        text-decoration: none;
        color: #409eff;
    }

</style>
